<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    content-class="unlockLibrary"
    v-infinite-scroll="getUnlockProducts" 
    infinite-scroll-disabled="busy" 
    infinite-scroll-distance="150"
  >
    <v-card>
      <v-toolbar dark color="grey-2">
        <v-btn icon dark @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>聊天解鎖商品</v-toolbar-title>
      </v-toolbar>
      <v-row no-gutters>
        <v-col
          style="padding: 6px"
          cols="4" 
          sm="3" 
          md="2" 
          lg="1" 
          xl="1" 
          v-for="product in products"
        >
          <v-card 
            class="story-item" 
            flat 
            @click="send(product)"
          >
            <v-img
              :src="$func.productImagePreview(product)"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.4)"
              height="100%"
              aspect-ratio="0.75"
              class="align-end"
            >
              <div class="description" :title="product.title">{{ product.title }}</div>
            </v-img>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      busy: false,
      page: 1,
      products: []
    }
  },
  methods: {
    open() {
      this.dialog = true
    },
    getUnlockProducts() {
      this.busy = true
      this.axios(`/portal/product?page=${this.page}&size=50`).then(response => {
        this.products = this.products.concat(
          response.data.data.filter(product => product.product_type == 'chat' && product.shelf)
        )
        if(this.page != response.data.last_page) {
          this.page += 1  
          this.busy = false
        }
      })
    },
    send(product) {
      this.$emit('send', product)
      this.dialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.unlockLibrary {
  .v-card {
    background: $grey-3;
  }
}
</style>